// Module
var code = `<div class="js-screen-about">
    <div class="js-screen-about-container">
        <terceraPictureBox imageUrl="{{.imageUrl}}" component_style="js-brand-image" />
        <terceraLabel text="{{.versionText}}" additionalClass="version-label"/>
        <terceraLabel text="{{.buildDateText}}" additionalClass="build-date-label"/>
    </div>
    <div class="js-brand-privacy">
        {{#if !.isHiddenCopyrightText}}
        <terceraLabel text="{{.copyrightText}}" />
        {{/if}}
    </div>
</div>`;
// Exports
export default code;